import styled from 'styled-components';

const CartListTitle = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.mediumExtraBold}
  margin-top: ${({ theme }) => theme.spaces.space_8};
  margin-left: ${({ theme }) => theme.spaces.space_16};
  margin-bottom: ${({ theme }) => theme.spaces.space_4};
  color: ${({ theme }) => theme.colors.night_blue};
`;

export default CartListTitle;
